import { useMutation } from '@tanstack/react-query';
import { showErrorToastNotification } from '../../../../@data';
import { unsubscribeFromEmailNotifications } from '../services/unsubscribe';

export const useUnsubscribe = () => {
  return useMutation({
    mutationFn: async ({ reportId, email }: { reportId: string; email: string }) => {
      return await unsubscribeFromEmailNotifications(reportId, email);
    },
    onError: () => {
      showErrorToastNotification({ text: 'Failed to unsubscribe. Please try again later.' });
    },
  });
};
